import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

/**
 * Guard que restringe acesso a rotas exclusivas do lado CLIENTE (relacionamento
 * com o contador). A empresa contadora nao tem contador — para ela essas telas
 * nao fazem sentido e sao bloqueadas.
 *
 * Inverso do `contadorAccessGuard`: usa o mesmo flag salvo no
 * sessionStorage/localStorage durante o login.
 */
export const naoContadorAccessGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (!isPlatformBrowser(platformId)) {
    return router.createUrlTree(['/sem-permissao']);
  }

  const isContador =
    sessionStorage.getItem('contador') === 'true' ||
    localStorage.getItem('contador') === 'true';

  return isContador ? router.createUrlTree(['/sem-permissao']) : true;
};
